import { Section } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import type { FC } from 'react';
import styled from 'styled-components';
import { GBSectionParagraph, GBSectionTitle } from './StyledElements';

const ContentWrapper = styled(Flex)`
  max-width: 800px;
`;

export interface InternalImpactProps {
  title: string;
  p1: string;
}

export const InternalImpact: FC<InternalImpactProps> = ({ title, p1 }) => {
  return (
    <Section py={[50, 50, 96]} px={20}>
      <GBSectionTitle tabIndex={0}>{title}</GBSectionTitle>
      <ContentWrapper flexDirection="column" alignItems="center" mt={20}>
        <GBSectionParagraph tabIndex={0}>{p1}</GBSectionParagraph>
      </ContentWrapper>
    </Section>
  );
};
